<template>
  <div class="header-ribbon-root">
    <div class="icon" :style="inlineStyle"></div>
    <div class="text">
      <div>{{contractName}}</div>
      <div>{{locationName}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderRibbon',
  props: ['contractName', 'locationName', 'logoUri'],
  computed: {
    inlineStyle () {
      if (this.logoUri == null)
      {
        return {}
      }
      else {
        return {
          background: `url(${this.logoUri}) no-repeat`,
          backgroundSize: 'cover' 
        }
      }
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.header-ribbon-root {
  padding: 0.5rem;
  background-color: lightgray;
  display: flex;

  > .icon {
    .mobile-media({margin-right: 0.5rem;});
    .desktop-media({margin-right: 2rem;});
    width: @icon-size;
    height: @icon-size;
    background: url('../assets/logo.png') no-repeat;
    background-size: cover;
  }

  > .text {
    display: flex;
    flex-direction: column;

    > div:first-child {
      font-size: @bigger-size;
      font-weight: bold;
    }

    > div:last-child {
      margin-top: 0.5rem;
      font-size: @smaller-size;
      letter-spacing: 0.05rem;
      text-transform: uppercase;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderRibbon.vue